import React, { FC, useEffect } from 'react';
import { LawyerCardProfile } from '../../../../../lawyer/card/LawyerCardProfile';
import { EntitiesCardBody } from '../../../../../components/entities-card/EntitiesCardBody';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { Connect, PropsFromRedux } from './LawyerSnippetContainer';
import { ResultsType } from '../../../../state/reducers/results.types';
import { useRestrictedModal } from '../../../../../components/modal/useRestrictedModal';
import styles from './lawyer_snippet.module.scss';
import { useUser } from '../../../../../user/useUser';
import { Paper } from '../../../../../components/paper/Paper';

type Props = {
  lawyer: NonNullable<ResultsType['snippets']['professional']>;
} & PropsFromRedux;

export const RawLawyerSnippet: FC<Props> = ({ originalQueryKey, lawyer }) => {
  const { accessPremium } = useUser();
  const { openRestrictedModal } = useRestrictedModal();

  useEffect(() => {
    doctrineAnalytics('Search ProfessionalDisplayed', {
      lawyer_id: lawyer.lawyerId,
      query_key: originalQueryKey,
    });
  }, []);

  const handleClick = (source: string) => () => {
    if (!accessPremium) {
      openRestrictedModal({ source });
    }
  };

  return (
    <Paper level={0} className={styles.container}>
      <EntitiesCardBody>
        <LawyerCardProfile
          lawyer={lawyer}
          onClick={handleClick('search-lawyer-snippet-header')}
          href={
            accessPremium
              ? `${lawyer.url}?source=search-lawyer-snippet-header`
              : undefined
          }
        />
      </EntitiesCardBody>
    </Paper>
  );
};

export const LawyerSnippet = Connect(RawLawyerSnippet);
